import analytics from 'shared/utils/analytics'

export const useModals = routerHelpers => {
	function open(modal, otherQueryParams = {}) {
		routerHelpers.pushQueryParams({modal, ...otherQueryParams})
		analytics.track(`${modal} modal opened`, otherQueryParams)
	}
	function close() {
		routerHelpers.pushQueryParams({modal: null})
	}
	function replace(modal) {
		routerHelpers.replaceQueryParams({modal})
	}

	return {
		open,
		close,
		replace,
	}
}
